import React from 'react';

const LEVELS = ['auto', '10s', '1m', '5m', '1h', '1d'];

const AggregationSelector = ({ value, onChange }) => (
  <div className="flex items-center gap-1.5">
    <span className="text-[10px] text-slate-500 uppercase tracking-wider mr-1">Group</span>
    <div className="flex bg-surface-800 border border-surface-600/30 rounded-lg overflow-hidden">
      {LEVELS.map((level) => (
        <button
          key={level}
          onClick={() => onChange(level)}
          className={`px-2 py-1 text-[10px] font-medium transition-colors ${
            value === level
              ? 'bg-brand-600/20 text-brand-400'
              : 'text-slate-500 hover:text-slate-300 hover:bg-surface-750'
          }`}
        >
          {level === 'auto' ? 'Auto' : level}
        </button>
      ))}
    </div>
  </div>
);

export default AggregationSelector;
